import { from, of } from 'rxjs';
import { mergeMap, map, catchError } from 'rxjs/operators';
import { combineEpics, ofType } from 'redux-observable';
import { authToken, teladocApi } from '@td/api';

import {
  FETCH_PRESCRIBER,
  fetchPrescriberSuccess,
  fetchPrescriberFailure,
  REFRESH_PRESCRIBER,
  refreshPrescriberSuccess,
  refreshPrescriberFailure,
  UPDATE_PRESCRIBER,
  updatePrescriberSuccess,
  updatePrescriberFailure,
  DEACTIVATE_PRESCRIBER,
  deactivatePrescriberSuccess,
  deactivatePrescriberFailure,
  REACTIVATE_PRESCRIBER,
  reactivatePrescriberSuccess,
  reactivatePrescriberFailure,
  CREATE_PRESCRIBER,
  createPrescriberSuccess,
  createPrescriberFailure
} from './actions';

const fetchPrescriberEpic = action$ =>
  action$.pipe(
    ofType(FETCH_PRESCRIBER),
    mergeMap(action =>
      from(teladocApi.get(`/v4/providers/${action.payload.providerId}/erx_registrations/${action.payload.prescriberId}`, {}, authToken.get())).pipe(
        map(response => fetchPrescriberSuccess(response)),
        catchError(error => of(fetchPrescriberFailure([error])))
      )
    ));

const refreshPrescriberEpic = action$ =>
  action$.pipe(
    ofType(REFRESH_PRESCRIBER),
    mergeMap(action =>
      from(teladocApi.get(`/v4/providers/${action.payload.providerId}/erx_registrations/${action.payload.prescriberId}`, {}, authToken.get())).pipe(
        map(response => refreshPrescriberSuccess(response)),
        catchError(error => of(refreshPrescriberFailure([error])))
      )
    ));

const updatePrescriberEpic = action$ =>
  action$.pipe(
    ofType(UPDATE_PRESCRIBER),
    mergeMap(action =>
      from(teladocApi.put(`/v4/providers/${action.payload.providerId}/erx_registrations/${action.payload.prescriberId}`, {}, authToken.get())).pipe(
        map(response => updatePrescriberSuccess(response)),
        catchError(error => of(updatePrescriberFailure([error])))
      )
    ));

const deactivatePrescriberEpic = action$ =>
  action$.pipe(
    ofType(DEACTIVATE_PRESCRIBER),
    mergeMap(action =>
      from(teladocApi.delete(`/v4/providers/${action.payload.providerId}/erx_registrations/${action.payload.prescriberId}`, {}, authToken.get())).pipe(
        map(response => deactivatePrescriberSuccess(response)),
        catchError(error => of(deactivatePrescriberFailure([error])))
      )
    ));

const reactivatePrescriberEpic = action$ =>
  action$.pipe(
    ofType(REACTIVATE_PRESCRIBER),
    mergeMap(action =>
      from(teladocApi.put(`/v4/providers/${action.payload.providerId}/erx_registrations/${action.payload.prescriberId}/reactivate`, {}, authToken.get())).pipe(
        map(response => reactivatePrescriberSuccess(response)),
        catchError(error => of(reactivatePrescriberFailure([error])))
      )
    ));

const createPrescriberEpic = action$ =>
  action$.pipe(
    ofType(CREATE_PRESCRIBER),
    mergeMap(action =>
      from(teladocApi.post(`/v4/providers/${action.payload.providerId}/erx_registrations`, {}, authToken.get())).pipe(
        map(response => createPrescriberSuccess(response)),
        catchError(error => of(createPrescriberFailure([error])))
      )
    ));

export {
  fetchPrescriberEpic,
  refreshPrescriberEpic,
  updatePrescriberEpic,
  deactivatePrescriberEpic,
  reactivatePrescriberEpic,
  createPrescriberEpic
};

export default combineEpics(
  fetchPrescriberEpic,
  refreshPrescriberEpic,
  updatePrescriberEpic,
  deactivatePrescriberEpic,
  reactivatePrescriberEpic,
  createPrescriberEpic
);
